import AircraftProperty from "./AircraftProperty";

// This maps data key-values from Spire responses to `VesselProperty`s
const AircraftGeneralDataPropertyMap = {
	[AircraftProperty.STATE]: "event",
	[AircraftProperty.FLIGHT_NUMBER]: "flight",
	[AircraftProperty.FLIGHT_OPERATOR]: "operator",
	[AircraftProperty.EQUIPMENT]: "equipment",
	[AircraftProperty.REGISTRATION]: "registration",
	[AircraftProperty.ALTITUDE]: "altitude",
	[AircraftProperty.CALL_SIGN]: "callsign",
	[AircraftProperty.DESTINATION_IATA]: "destination_iata",
	[AircraftProperty.DESTINATION_ICAO]: "destination_icao",
	[AircraftProperty.ORIGIN_IATA]: "origin_iata",
	[AircraftProperty.ORIGIN_ICAO]: "origin_icao",
	[AircraftProperty.TIMESTAMP]: "timestamp"
};
export default AircraftGeneralDataPropertyMap;
